import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackMoreMenuClick, trackMoreMenuMoveToArchiveClick, trackMoreMenuMoveToSpamClick } from './tracking';
import { moveToArchive, moveToSpam } from '../../actions/chatOperations';
import { ChatMenu } from '../../components/ChatMenu';
import { chatListSelector, currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';
import { EAvailableActions } from '../../types/availableActions';
import { ERoute } from '../../types/route';

export const ChatMenuContainer = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);

  const currentChat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);
  const { currentRoute } = useSelector(chatListSelector);

  const { availableActions, offer, chatId } = currentChat || {};

  const dispatch = useDispatch();

  const isArchiveAvailable = availableActions?.includes(EAvailableActions.Archive);
  const isBlockAvailable = availableActions?.includes(EAvailableActions.Block);

  const handleSpamClick = React.useCallback(() => {
    dispatch(moveToSpam(chatId as string));
    trackMoreMenuMoveToSpamClick(offer, opponentId);
  }, [dispatch, chatId, offer, opponentId]);

  const handleArchiveClick = React.useCallback(() => {
    dispatch(moveToArchive(chatId as string));
    trackMoreMenuMoveToArchiveClick(offer, opponentId, chatId);
  }, [dispatch, chatId, offer, opponentId]);

  const handleToggleMenu = React.useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        trackMoreMenuClick(offer, opponentId);
      }

      setIsMenuOpen(isOpen);
    },
    [offer, opponentId],
  );

  if (currentRoute !== ERoute.Messages || (!isArchiveAvailable && !isBlockAvailable)) {
    return null;
  }

  return (
    <ChatMenu
      isOpen={isMenuOpen}
      isArchiveAvailable={isArchiveAvailable}
      isBlockAvailable={isBlockAvailable}
      toggleMenu={handleToggleMenu}
      onSpamClick={handleSpamClick}
      onArchiveClick={handleArchiveClick}
    />
  );
};
